import AdminEmptyStateRow from "../shared/AdminEmptyStateRow";
import AdminTableCard from "../shared/AdminTableCard";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const QuotationsTable = ({
  records,
  search,
  onShowProducts,
  onPrint,
  onEdit,
  onDelete,
}) => (
  <AdminTableCard>
    <table className="w-full table-fixed text-sm">
      <colgroup>
        <col className="w-[10%]" />
        <col className="w-[13%]" />
        <col className="w-[20%]" />
        <col className="w-[11%]" />
        <col className="w-[12%]" />
        <col className="w-[13%]" />
        <col className="w-[21%]" />
      </colgroup>
      <thead className="bg-gray-50 text-gray-600">
        <tr>
          <th className="px-3 py-3 text-center font-semibold">Quotation No</th>
          <th className="px-3 py-3 text-center font-semibold">Bill Title</th>
          <th className="px-3 py-3 text-center font-semibold">Company Name</th>
          <th className="px-3 py-3 text-center font-semibold">Date</th>
          <th className="px-3 py-3 text-center font-semibold">Product</th>
          <th className="px-3 py-3 text-center font-semibold">Total Amount</th>
          <th className="px-3 py-3 text-center font-semibold">Action</th>
        </tr>
      </thead>
      <tbody>
        {records.length === 0 ? (
          <AdminEmptyStateRow
            colSpan={7}
            message={
              search.trim()
                ? "No matching quotations found."
                : "No quotations yet."
            }
          />
        ) : (
          records.map((record) => (
            <tr key={record._id} className="border-t border-gray-100 align-top">
              <td className="px-3 py-3 text-center font-medium text-gray-800">
                {record.quotationNo}
              </td>
              <td className="px-3 py-3 text-center text-gray-700 break-words">
                {record.billTitle}
              </td>
              <td className="px-3 py-3 text-center text-gray-700 break-words">
                {record.companyName}
              </td>
              <td className="px-3 py-3 text-center text-gray-700">
                {formatDate(record.date)}
              </td>
              <td className="px-3 py-3 text-center">
                <button
                  type="button"
                  onClick={() => onShowProducts(record)}
                  className="rounded-lg border border-blue-200 bg-blue-50 px-2.5 py-1 text-[11px] font-medium text-blue-600 hover:bg-blue-100"
                >
                  Show Products
                  {Array.isArray(record.items) && record.items.length > 0
                    ? ` (${record.items.length})`
                    : ""}
                </button>
              </td>
              <td className="px-3 py-3 text-center text-gray-700">
                {Number(record.totalAmount || 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td className="px-2 py-3">
                <div className="grid grid-cols-3 gap-1.5">
                  <button
                    onClick={() => onPrint(record)}
                    className="rounded-lg border border-indigo-200 bg-indigo-50 px-2 py-1.5 text-[11px] font-medium text-indigo-600 transition-colors hover:bg-indigo-100"
                  >
                    Print
                  </button>
                  <button
                    onClick={() => onEdit(record)}
                    className="rounded-lg border border-blue-200 bg-blue-50 px-2 py-1.5 text-[11px] font-medium text-blue-600 transition-colors hover:bg-blue-100"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => onDelete(record)}
                    className="rounded-lg border border-red-200 bg-red-50 px-2 py-1.5 text-[11px] font-medium text-red-500 transition-colors hover:bg-red-100"
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </AdminTableCard>
);

export default QuotationsTable;